/** @jsx jsx */
import React from "react";
import { jsx, Text, Flex, Box, Progress } from "theme-ui";

class StatusBox extends React.PureComponent {
  render() {
    const { className, progressClassName, blockName, value, maxValue, ratio } =
      this.props;
    return (
      // <Col>
        <Flex
          sx={{
            borderColor: "#d9d9d9",
            backgroundColor: "white",
            borderWidth: "1px",
            borderStyle: "solid",
            borderRadius: "4px",
            gap: "2px",
            flexDirection: "column",
            width:['100%', '33%'],
            marginBottom:'5px'
          }}
        >
          <Flex
            className={className}
            p={2}
            sx={{
              gap: "16px",
            }}
          >
            <div
              sx={{ marginTop: "2px", marginLeft: "2px" }}
              className="contrib-stat"
            />
            <Flex
              sx={{
                flexDirection: "column",
                gap: "4px",
              }}
            >
              <Text
                sx={{
                  fontSize: "14px",
                }}
              >
                {blockName}
              </Text>

              <Box>
                {value} / {maxValue} - {ratio} %
              </Box>
            </Flex>
          </Flex>
          <Progress
            className={`${progressClassName} expec-status`}
            sx={{ backgroundColor: "#d9d9d9" }}
            max={1}
            value={value / maxValue}
          />
        </Flex>
      // </Col>
    );
  }
}

export default StatusBox;
